import React from 'react';
import InstagramIcon from '../assets/instagram.svg';
import LinkedinIcon from '../assets/linkedin.svg';
import FacebookIcon from '../assets/facebook.svg';
import TwitterIcon from '../assets/twitter.svg';
import TikTokIcon from '../assets/tiktok.svg';
import MetaIcon from '../assets/meta.svg';
import { useSocial } from '../context/socialProvider';

interface IconWrapperProps {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

const IconWrapper = ({ children, size = 'md' }: IconWrapperProps) => {
  return (
    <div className={`flex items-center justify-center ${sizeClasses[size]}`}>
      {children}
    </div>
  );
};

interface PlatformConfigItem {
  name: string;
  icon: string;
  comingSoon?: boolean;
}

export const platformConfig: Record<number, PlatformConfigItem> = {
  1: {
    name: 'Instagram',
    icon: InstagramIcon,
  },
  2: {
    name: 'Facebook',
    icon: FacebookIcon,
  },
  3: {
    name: 'LinkedIn',
    icon: LinkedinIcon,
    comingSoon: true,
  },
  4: {
    name: 'TikTok',
    icon: TikTokIcon,
    comingSoon: true,
  },
  5: {
    name: 'X (Twitter)',
    icon: TwitterIcon,
    comingSoon: true,
  },
};

interface SocialIconProps {
  socialId?: number; // Now using socialId instead of platform
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const PlatformIcon = ({
  socialId,
  size = 'md',
  className = '',
}: SocialIconProps) => {
  const { currentSocial, availableSocials } = useSocial();

  // Find the social account either by provided ID or use current
  const social = socialId
    ? availableSocials.find((s) => s.id === socialId)
    : currentSocial;

  if (!social) return null;

  // Get platform type from the social account
  const platformType = social.provider;
  const config = platformConfig[platformType];

  if (!config) return null;

  return (
    <IconWrapper size={size}>
      <img
        src={config.icon}
        alt={config.name}
        className={`${sizeClasses[size]} ${className}`}
      />
    </IconWrapper>
  );
};

// Helper to get platform details from a social account
export const getSocialPlatformDetails = (
  social?: { provider: number } | null
) => {
  if (!social) return null;
  return platformConfig[social.provider];
};
